export class Col {
  title: string;
  attributeName: string;
  tooltip?: string;
  classAttribute?: string;
  pipes?: string;

  constructor(title: string, attributeName: string, tooltip: string = null, classAttribute: string = null, pipes: string = null) {
    this.title = title;
    this.attributeName = attributeName;
    this.tooltip = tooltip;
    this.classAttribute = classAttribute;
    this.pipes = pipes;
  }
}
